module.exports = __webpack_public_path__ + "images/big-news.f718decf6110e368211ffc3f4e563114.png";